import React from 'react';
import { IconProps } from '../types';
const MinecraftEndCrystal: React.FC<IconProps> = ({ size = 24, className, style }) => (
<svg width={size} height={size} className={className} style={style} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
<rect x="2" y="1" width="1" height="1" fill="rgba(179, 216, 221, 255)" />
<rect x="3" y="1" width="1" height="1" fill="rgba(249, 253, 254, 255)" />
<rect x="4" y="1" width="1" height="1" fill="rgba(249, 253, 254, 255)" />
<rect x="5" y="1" width="1" height="1" fill="rgba(249, 253, 254, 255)" />
<rect x="6" y="1" width="1" height="1" fill="rgba(249, 253, 254, 255)" />
<rect x="7" y="1" width="1" height="1" fill="rgba(249, 253, 254, 255)" />
<rect x="8" y="1" width="1" height="1" fill="rgba(249, 253, 254, 255)" />
<rect x="9" y="1" width="1" height="1" fill="rgba(249, 253, 254, 255)" />
<rect x="10" y="1" width="1" height="1" fill="rgba(249, 253, 254, 255)" />
<rect x="11" y="1" width="1" height="1" fill="rgba(249, 253, 254, 255)" />
<rect x="12" y="1" width="1" height="1" fill="rgba(249, 253, 254, 255)" />
<rect x="13" y="1" width="1" height="1" fill="rgba(249, 253, 254, 255)" />
<rect x="14" y="1" width="1" height="1" fill="rgba(249, 253, 254, 255)" />
<rect x="2" y="2" width="1" height="1" fill="rgba(249, 253, 254, 255)" />
<rect x="8" y="2" width="1" height="1" fill="rgba(149, 77, 187, 255)" />
<rect x="14" y="2" width="1" height="1" fill="rgba(156, 189, 193, 255)" />
<rect x="2" y="3" width="1" height="1" fill="rgba(249, 253, 254, 255)" />
<rect x="7" y="3" width="1" height="1" fill="rgba(149, 77, 187, 255)" />
<rect x="8" y="3" width="1" height="1" fill="rgba(220, 199, 230, 255)" />
<rect x="9" y="3" width="1" height="1" fill="rgba(149, 77, 187, 255)" />
<rect x="14" y="3" width="1" height="1" fill="rgba(156, 189, 193, 255)" />
<rect x="2" y="4" width="1" height="1" fill="rgba(249, 253, 254, 255)" />
<rect x="4" y="4" width="1" height="1" fill="rgba(95, 39, 125, 255)" />
<rect x="5" y="4" width="1" height="1" fill="rgba(95, 39, 125, 255)" />
<rect x="6" y="4" width="1" height="1" fill="rgba(149, 77, 187, 255)" />
<rect x="7" y="4" width="1" height="1" fill="rgba(190, 149, 212, 255)" />
<rect x="8" y="4" width="1" height="1" fill="rgba(220, 199, 230, 255)" />
<rect x="9" y="4" width="1" height="1" fill="rgba(190, 149, 212, 255)" />
<rect x="10" y="4" width="1" height="1" fill="rgba(149, 77, 187, 255)" />
<rect x="11" y="4" width="1" height="1" fill="rgba(95, 39, 125, 255)" />
<rect x="12" y="4" width="1" height="1" fill="rgba(95, 39, 125, 255)" />
<rect x="14" y="4" width="1" height="1" fill="rgba(156, 189, 193, 255)" />
<rect x="2" y="5" width="1" height="1" fill="rgba(249, 253, 254, 255)" />
<rect x="4" y="5" width="1" height="1" fill="rgba(95, 39, 125, 255)" />
<rect x="5" y="5" width="1" height="1" fill="rgba(149, 77, 187, 255)" />
<rect x="6" y="5" width="1" height="1" fill="rgba(190, 149, 212, 255)" />
<rect x="7" y="5" width="1" height="1" fill="rgba(190, 149, 212, 255)" />
<rect x="8" y="5" width="1" height="1" fill="rgba(207, 178, 221, 255)" />
<rect x="9" y="5" width="1" height="1" fill="rgba(190, 149, 212, 255)" />
<rect x="10" y="5" width="1" height="1" fill="rgba(190, 149, 212, 255)" />
<rect x="11" y="5" width="1" height="1" fill="rgba(149, 77, 187, 255)" />
<rect x="12" y="5" width="1" height="1" fill="rgba(95, 39, 125, 255)" />
<rect x="14" y="5" width="1" height="1" fill="rgba(179, 216, 221, 255)" />
<rect x="2" y="6" width="1" height="1" fill="rgba(249, 253, 254, 255)" />
<rect x="4" y="6" width="1" height="1" fill="rgba(149, 77, 187, 255)" />
<rect x="5" y="6" width="1" height="1" fill="rgba(190, 149, 212, 255)" />
<rect x="6" y="6" width="1" height="1" fill="rgba(190, 149, 212, 255)" />
<rect x="7" y="6" width="1" height="1" fill="rgba(207, 178, 221, 255)" />
<rect x="8" y="6" width="1" height="1" fill="rgba(226, 6, 39, 255)" />
<rect x="9" y="6" width="1" height="1" fill="rgba(207, 178, 221, 255)" />
<rect x="10" y="6" width="1" height="1" fill="rgba(190, 149, 212, 255)" />
<rect x="11" y="6" width="1" height="1" fill="rgba(190, 149, 212, 255)" />
<rect x="12" y="6" width="1" height="1" fill="rgba(149, 77, 187, 255)" />
<rect x="14" y="6" width="1" height="1" fill="rgba(179, 216, 221, 255)" />
<rect x="2" y="7" width="1" height="1" fill="rgba(249, 253, 254, 255)" />
<rect x="3" y="7" width="1" height="1" fill="rgba(149, 77, 187, 255)" />
<rect x="4" y="7" width="1" height="1" fill="rgba(190, 149, 212, 255)" />
<rect x="5" y="7" width="1" height="1" fill="rgba(190, 149, 212, 255)" />
<rect x="6" y="7" width="1" height="1" fill="rgba(207, 178, 221, 255)" />
<rect x="7" y="7" width="1" height="1" fill="rgba(226, 6, 39, 255)" />
<rect x="8" y="7" width="1" height="1" fill="rgba(183, 5, 32, 255)" />
<rect x="9" y="7" width="1" height="1" fill="rgba(207, 178, 221, 255)" />
<rect x="10" y="7" width="1" height="1" fill="rgba(207, 178, 221, 255)" />
<rect x="11" y="7" width="1" height="1" fill="rgba(190, 149, 212, 255)" />
<rect x="12" y="7" width="1" height="1" fill="rgba(190, 149, 212, 255)" />
<rect x="13" y="7" width="1" height="1" fill="rgba(95, 39, 125, 255)" />
<rect x="14" y="7" width="1" height="1" fill="rgba(156, 189, 193, 255)" />
<rect x="2" y="8" width="1" height="1" fill="rgba(179, 216, 221, 255)" />
<rect x="3" y="8" width="1" height="1" fill="rgba(190, 149, 212, 255)" />
<rect x="4" y="8" width="1" height="1" fill="rgba(220, 199, 230, 255)" />
<rect x="5" y="8" width="1" height="1" fill="rgba(220, 199, 230, 255)" />
<rect x="6" y="8" width="1" height="1" fill="rgba(226, 6, 39, 255)" />
<rect x="7" y="8" width="1" height="1" fill="rgba(226, 6, 39, 255)" />
<rect x="8" y="8" width="1" height="1" fill="rgba(190, 149, 212, 255)" />
<rect x="9" y="8" width="1" height="1" fill="rgba(206, 6, 36, 255)" />
<rect x="10" y="8" width="1" height="1" fill="rgba(226, 6, 39, 255)" />
<rect x="11" y="8" width="1" height="1" fill="rgba(207, 178, 221, 255)" />
<rect x="12" y="8" width="1" height="1" fill="rgba(207, 178, 221, 255)" />
<rect x="13" y="8" width="1" height="1" fill="rgba(149, 77, 187, 255)" />
<rect x="14" y="8" width="1" height="1" fill="rgba(95, 39, 125, 255)" />
<rect x="2" y="9" width="1" height="1" fill="rgba(156, 189, 193, 255)" />
<rect x="3" y="9" width="1" height="1" fill="rgba(149, 77, 187, 255)" />
<rect x="4" y="9" width="1" height="1" fill="rgba(190, 149, 212, 255)" />
<rect x="5" y="9" width="1" height="1" fill="rgba(190, 149, 212, 255)" />
<rect x="6" y="9" width="1" height="1" fill="rgba(207, 178, 221, 255)" />
<rect x="7" y="9" width="1" height="1" fill="rgba(190, 149, 212, 255)" />
<rect x="8" y="9" width="1" height="1" fill="rgba(190, 149, 212, 255)" />
<rect x="9" y="9" width="1" height="1" fill="rgba(190, 149, 212, 255)" />
<rect x="10" y="9" width="1" height="1" fill="rgba(207, 178, 221, 255)" />
<rect x="11" y="9" width="1" height="1" fill="rgba(190, 149, 212, 255)" />
<rect x="12" y="9" width="1" height="1" fill="rgba(149, 77, 187, 255)" />
<rect x="13" y="9" width="1" height="1" fill="rgba(95, 39, 125, 255)" />
<rect x="14" y="9" width="1" height="1" fill="rgba(156, 189, 193, 255)" />
<rect x="2" y="10" width="1" height="1" fill="rgba(249, 253, 254, 255)" />
<rect x="4" y="10" width="1" height="1" fill="rgba(149, 77, 187, 255)" />
<rect x="5" y="10" width="1" height="1" fill="rgba(190, 149, 212, 255)" />
<rect x="6" y="10" width="1" height="1" fill="rgba(190, 149, 212, 255)" />
<rect x="7" y="10" width="1" height="1" fill="rgba(207, 178, 221, 255)" />
<rect x="8" y="10" width="1" height="1" fill="rgba(226, 6, 39, 255)" />
<rect x="9" y="10" width="1" height="1" fill="rgba(206, 6, 36, 255)" />
<rect x="10" y="10" width="1" height="1" fill="rgba(190, 149, 212, 255)" />
<rect x="11" y="10" width="1" height="1" fill="rgba(149, 77, 187, 255)" />
<rect x="12" y="10" width="1" height="1" fill="rgba(149, 77, 187, 255)" />
<rect x="14" y="10" width="1" height="1" fill="rgba(179, 216, 221, 255)" />
<rect x="2" y="11" width="1" height="1" fill="rgba(249, 253, 254, 255)" />
<rect x="4" y="11" width="1" height="1" fill="rgba(95, 39, 125, 255)" />
<rect x="5" y="11" width="1" height="1" fill="rgba(149, 77, 187, 255)" />
<rect x="6" y="11" width="1" height="1" fill="rgba(149, 77, 187, 255)" />
<rect x="7" y="11" width="1" height="1" fill="rgba(190, 149, 212, 255)" />
<rect x="8" y="11" width="1" height="1" fill="rgba(207, 178, 221, 255)" />
<rect x="9" y="11" width="1" height="1" fill="rgba(190, 149, 212, 255)" />
<rect x="10" y="11" width="1" height="1" fill="rgba(149, 77, 187, 255)" />
<rect x="11" y="11" width="1" height="1" fill="rgba(149, 77, 187, 255)" />
<rect x="12" y="11" width="1" height="1" fill="rgba(95, 39, 125, 255)" />
<rect x="14" y="11" width="1" height="1" fill="rgba(179, 216, 221, 255)" />
<rect x="2" y="12" width="1" height="1" fill="rgba(249, 253, 254, 255)" />
<rect x="4" y="12" width="1" height="1" fill="rgba(95, 39, 125, 255)" />
<rect x="5" y="12" width="1" height="1" fill="rgba(95, 39, 125, 255)" />
<rect x="6" y="12" width="1" height="1" fill="rgba(149, 77, 187, 255)" />
<rect x="7" y="12" width="1" height="1" fill="rgba(149, 77, 187, 255)" />
<rect x="8" y="12" width="1" height="1" fill="rgba(207, 178, 221, 255)" />
<rect x="9" y="12" width="1" height="1" fill="rgba(149, 77, 187, 255)" />
<rect x="10" y="12" width="1" height="1" fill="rgba(149, 77, 187, 255)" />
<rect x="11" y="12" width="1" height="1" fill="rgba(95, 39, 125, 255)" />
<rect x="12" y="12" width="1" height="1" fill="rgba(95, 39, 125, 255)" />
<rect x="14" y="12" width="1" height="1" fill="rgba(179, 216, 221, 255)" />
<rect x="2" y="13" width="1" height="1" fill="rgba(249, 253, 254, 255)" />
<rect x="7" y="13" width="1" height="1" fill="rgba(95, 39, 125, 255)" />
<rect x="8" y="13" width="1" height="1" fill="rgba(149, 77, 187, 255)" />
<rect x="9" y="13" width="1" height="1" fill="rgba(95, 39, 125, 255)" />
<rect x="14" y="13" width="1" height="1" fill="rgba(179, 216, 221, 255)" />
<rect x="2" y="14" width="1" height="1" fill="rgba(249, 253, 254, 255)" />
<rect x="3" y="14" width="1" height="1" fill="rgba(156, 189, 193, 255)" />
<rect x="4" y="14" width="1" height="1" fill="rgba(179, 216, 221, 255)" />
<rect x="5" y="14" width="1" height="1" fill="rgba(179, 216, 221, 255)" />
<rect x="6" y="14" width="1" height="1" fill="rgba(179, 216, 221, 255)" />
<rect x="7" y="14" width="1" height="1" fill="rgba(179, 216, 221, 255)" />
<rect x="8" y="14" width="1" height="1" fill="rgba(156, 189, 193, 255)" />
<rect x="9" y="14" width="1" height="1" fill="rgba(156, 189, 193, 255)" />
<rect x="10" y="14" width="1" height="1" fill="rgba(179, 216, 221, 255)" />
<rect x="11" y="14" width="1" height="1" fill="rgba(179, 216, 221, 255)" />
<rect x="12" y="14" width="1" height="1" fill="rgba(179, 216, 221, 255)" />
<rect x="13" y="14" width="1" height="1" fill="rgba(179, 216, 221, 255)" />
<rect x="14" y="14" width="1" height="1" fill="rgba(179, 216, 221, 255)" />
</svg>);
export default MinecraftEndCrystal;